import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { 
  FaPhone, 
  FaWhatsapp, 
  FaEnvelope, 
  FaMapMarkerAlt,
  FaClock,
  FaArrowRight
} from 'react-icons/fa';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simular envío del formulario
    setTimeout(() => {
      setIsSubmitting(false);
      alert('¡Gracias por tu mensaje! Te contactaré pronto.');
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: ''
      });
    }, 2000);
  };

  const contactInfo = [
    {
      icon: <FaPhone />,
      title: "Teléfono",
      value: "654 38 49 37",
      link: "tel:+34654384937"
    },
    {
      icon: <FaWhatsapp />,
      title: "WhatsApp",
      value: "654 38 49 37",
      link: "https://wa.me/34654384937"
    },
    {
      icon: <FaEnvelope />,
      title: "Email",
      value: "javier.m.v.2001@gmail.com",
      link: "mailto:javier.m.v.2001@gmail.com"
    },
  ];

  const schedule = [
    { day: "Lunes - Viernes", hours: "9:00 - 21:00" },
  ];

  return (
    <div className="contact">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="container">
          <motion.div 
            className="contact-hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1>Contacto</h1>
            <p className="subtitle">
              Estoy aquí para ayudarte. Ponte en contacto conmigo y te responderé lo antes posible.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Contact Info Section */}
      <section className="contact-info section">
        <div className="container">
          <motion.div 
            className="section-header"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2>Información de Contacto</h2>
            <p>
              No dudes en contactarme por cualquier consulta. 
              Estoy disponible para ayudarte con tu recuperación, ya sea en su domicilio o en mi consulta en San Lorenzo de El Escorial.
            </p>
          </motion.div>
          
          <div className="contact-grid">
            {contactInfo.map((info, index) => (
              <motion.a 
                key={index}
                href={info.link}
                className="contact-card"
                target={info.link.startsWith('http') ? '_blank' : undefined}
                rel={info.link.startsWith('http') ? 'noopener noreferrer' : undefined}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                whileHover={{ 
                  scale: 1.05,
                  boxShadow: "0 10px 30px rgba(0, 0, 0, 0.15)"
                }}
              >
                <div className="contact-icon">
                  {info.icon}
                </div>
                <div className="contact-content">
                  <h3>{info.title}</h3>
                  <span className="contact-value">{info.value}</span>
                </div>
                <div className="contact-arrow">
                  <FaArrowRight />
                </div>
              </motion.a>
            ))}
          </div>
        </div>
      </section>

      {/* Schedule Section */}
      <section className="schedule section">
        <div className="container">
          <motion.div 
            className="schedule-content"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <div className="schedule-header">
              <h2>Horarios de Atención</h2>
              <p>Adapto mis horarios a tu disponibilidad</p>
            </div>
            
            <div className="schedule-grid">
              {schedule.map((item, index) => (
                <motion.div 
                  key={index}
                  className="schedule-item"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  viewport={{ once: true }}
                >
                  <div className="schedule-icon">
                    <FaClock />
                  </div>
                  <div className="schedule-text">
                    <h4>{item.day}</h4>
                    <span>{item.hours}</span>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>

      {/* Map Section */}
      <section className="map-section section">
        <div className="container">
          <motion.div 
            className="map-content"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2>Ubicación</h2>
            <p>Encuentrame fácilmente en la Sierra de Madrid</p>
            
            <div className="map-container">
              <div className="map-embed">
                <iframe
                  title="Ubicación - Calle Las Pozas 1, San Lorenzo de El Escorial"
                  src={"https://www.google.com/maps?q=" + encodeURIComponent("San Lorenzo de El Escorial") + "&output=embed"}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
              <a
                className="map-link"
                href={"https://www.google.com/maps?q=" + encodeURIComponent("San Lorenzo de El Escorial")}
                target="_blank"
                rel="noopener noreferrer"
              >
                Abrir en Google Maps
              </a>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Contact; 